import {
  GET_SEND_RA_REQUEST,
  GET_SEND_RA_SUCCESS,
  GET_SEND_RA_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const sendRA = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEND_RA_REQUEST });

  return axios({
    method: "POST",
    url: `${BASEURL}create/ratobergen`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values
  })
    .then((response) => {
      return dispatch({
        type: GET_SEND_RA_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEND_RA_ERROR,
        payload: [],
      });
    });
};
